module.exports = __webpack_public_path__ + "static/media/ai-champ.30486d8a.png";